<template>
  <div id="app">
    <div class="head">
      <heads :selectNav1="selectNav" v-on:childNav="changeNav"/>
    </div>
    <div :class="selectPath == 'about' ? '' : 'hide'">
      <aboutUs></aboutUs>
    </div>
    <div :class="selectPath == 'index' ? '' : 'hide'">
      <index></index>
    </div>
    <div :class="selectPath == 'product' ? '' : 'hide'">
      <productServer></productServer>
    </div>
    <div :class="selectPath == 'relation' ? '' : 'hide'">
      <relation></relation>
    </div>
    <div :class="selectPath == 'solution' ? '' : 'hide'">
      <solution></solution>
    </div>

    <!-- <router-view /> -->
    <Font v-on:childNav="changeNav"/>
  </div>
</template>


<script>
import heads from "./components/views/heads";
import Font from "./components/views/foot";

import aboutUs from "./components/aboutUs";
import index from "./components/index";
import productServer from "./components/productServer";
import relation from "./components/relation";
import solution from "./components/solution";

export default {
  name: "App",
  data(){
    return {
      selectNav: 0,
      nav: {
        relation: 5,
        about: 4,
        login: 3,
        solution: 2,
        product: 1,
        index: 0,
      },
      selectPath: "index"
    }
  },
  mounted() {
    // var href = location.pathname;
    // var path = href.replace("/","");
    // var path = path.replace(".html","");
    var search = location.search;
    var path = search.replace("?path=","");
    if(!this.nav[path]){
      this.selectNav = 0;
      this.selectPath = 'index';
    }else {
      this.selectNav = this.nav[path];
      this.selectPath = path;
    }
  },
  methods: {
    changeNav: function(path) {
        this.selectPath = path;
        this.selectNav = this.nav[path];
        history.replaceState(null,null,'index.html?path='+path);
        // this.$router.push('/'+path);
    }
  },
  components: {
    heads,
    Font,
    aboutUs,
    index,
    productServer,
    relation,
    solution
  }
};
</script>

<style>
.head {
  position: relative;
}
.pd_b20{
  padding: 0 20%;
  box-sizing: border-box;
}
.title {
  font-size: 34px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue